import React from 'react';

const NotFound = () => {
    return (
        <div id="notfound">
		<div class="notfound">
			<div class="notfound-404">
				<h1>4<span style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/emoji.png`}}></span>4</h1>
			</div>
			<h2>¡Ups! Página no encontrada</h2>
			<p>Lo sentimos, la página que buscas no está disponible.</p>
			<a href="/">Volver a la página de inicio</a>
		</div>
	</div>
    );
};

export default NotFound;